import React from "react";
import {Search, Divider, Label, Stack} from "@nike/podium";
import {DirectionFilter, MonthOption} from "../../common/data/types";

type FilterDrawerProps = {
    open: boolean;
    dir: DirectionFilter;
    onSetDir: (d: DirectionFilter) => void;
    threshold: number;
    onSetThreshold: (t: number) => void;
    monthOptions: MonthOption[];
    persistOnly: boolean;
    onTogglePersist: () => void;
    excludeSpecial: boolean;
    onToggleExcludeSpecial: () => void;
    searchCode: string;
    onSearchCodeChange: (v: string) => void;
    searchSize: string;
    onSearchSizeChange: (v: string) => void;
};

const DIRECTIONS: {value: DirectionFilter; label: string}[] = [
    {value: 'all', label: 'All'},
    {value: 'zero', label: 'WMS = 0'},
    {value: 'over', label: 'WMS > CI'},
    {value: 'under', label: 'WMS < CI'},
];

export function FilterDrawer({
    open, dir, onSetDir, threshold, onSetThreshold, monthOptions,
    persistOnly, onTogglePersist, excludeSpecial, onToggleExcludeSpecial,
    searchCode, onSearchCodeChange, searchSize, onSearchSizeChange
}: FilterDrawerProps) {

    return (
        <div className={`im-filter-drawer ${open ? 'open' : ''}`}>
            <Stack horizontal align="center" gap="m" wrap className="im-filter-inner">
                <Stack horizontal align="center" gap="s">
                    <Label font="body-4" className="im-fg-lbl">Direction</Label>
                    <div className="im-pill-group">
                        {DIRECTIONS.map(d => (
                            <button
                                key={d.value}
                                className={`im-pill ${dir === d.value ? 'active' : ''}`}
                                onClick={() => onSetDir(d.value)}
                            >
                                {d.label}
                            </button>
                        ))}
                    </div>
                </Stack>

                <Divider vertical />

                <Stack horizontal align="center" gap="s">
                    <Label font="body-4" className="im-fg-lbl">Persistent since</Label>
                    <button
                        className={`im-pill tinted ${persistOnly ? 'active' : ''}`}
                        onClick={onTogglePersist}
                    >
                        Persistent only
                    </button>
                    <select
                        id="month-select"
                        className="im-month-select"
                        value={String(threshold)}
                        onChange={e => onSetThreshold(parseInt(e.target.value))}
                        aria-label="Persistent since month"
                    >
                        {monthOptions.map(o => (
                            <option key={o.threshold} value={String(o.threshold)}>
                                {o.label}
                            </option>
                        ))}
                    </select>
                </Stack>

                <Divider vertical />

                <Stack horizontal align="center" gap="s">
                    <Label font="body-4" className="im-fg-lbl">Search</Label>
                    <div className="im-filter-search">
                        <Search
                            id="filter-material"
                            label="Search materials"
                            placeholder="Material…"
                            value={searchCode}
                            onValueChange={onSearchCodeChange}
                        />
                    </div>
                    <div className="im-filter-search">
                        <Search
                            id="filter-size"
                            label="Search sizes"
                            placeholder="Size…"
                            value={searchSize}
                            onValueChange={onSearchSizeChange}
                        />
                    </div>
                </Stack>

                <Divider vertical />

                <Stack horizontal align="center" gap="s">
                    <Label font="body-4" className="im-fg-lbl">Materials</Label>
                    <button
                        className={`im-pill accent ${excludeSpecial ? 'active' : ''}`}
                        onClick={onToggleExcludeSpecial}
                    >
                        Excl. 999 &amp; 997 colors
                    </button>
                </Stack>
            </Stack>
        </div>
    );
}
